module.exports = __webpack_public_path__ + "img/chevron-right-white.c86379d5.svg";